import { render } from "./RulesConfirmedModal.vue?vue&type=template&id=3e863f20&scoped=true"
import script from "./RulesConfirmedModal.vue?vue&type=script&lang=js"
export * from "./RulesConfirmedModal.vue?vue&type=script&lang=js"

import "./RulesConfirmedModal.vue?vue&type=style&index=0&id=3e863f20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e863f20"]])

export default __exports__